module.exports = __webpack_public_path__ + "img/prijsHome.b85b893e.svg";